import { message } from 'antd';
import React, { Component } from 'react';
import '../App.css';
import '../style/home.css';
//import ArquivoPage from "./ArquivoPage";
import MapPage_Covid from './MapPage_Covid';

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal2Visible: false
    };
    this.scrollTo = this.scrollTo.bind(this);
  }
  setModal2Visible(modal2Visible) {
    this.setState({ modal2Visible });
  }

  scrollTo(item) {
    console.log(item);
    window.scrollTo({
      top: document.getElementById(item.key).getBoundingClientRect().top,
      behavior: 'smooth'
    });
  }

  render() {
    const leftDivClass = 'slide ' + (this.props.left ? ' left' : '');
    const rightDivClass = 'slideRight ' + (this.props.right ? ' right' : '');
    //console.log(() => this.props.toggleLeft(null));
    return (
      <MapPage_Covid
        toggleLeft={this.props.toggleRight}
        setIsLoading={this.props.setIsLoading}
        isLoading={this.props.isLoading}
        projectFromDB={this.props.projectFromDB}
      />
    );
  }

  handleChange(date) {
    message.info('Selected Date: ' + (date ? date.toString() : ''));
    this.setState({ date });
  }
}

export default Home;
